import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Gift({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Gift</title>
      <rect
        x="2"
        y="7"
        width="20"
        height="5"
        rx="2"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V12Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7V21"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5.23438C5 4.00429 5.99718 3 7.22727 3H8.12903C10.2669 3 12 4.73309 12 6.87097V6.87097C12 6.94223 11.9422 7 11.871 7H6.76C5.78798 7 5 6.2064 5 5.23438V5.23438Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 5.23438C19 4.00429 18.0028 3 16.7727 3H15.871C13.7331 3 12 4.73309 12 6.87097V6.87097C12 6.94223 12.0578 7 12.129 7H17.24C18.212 7 19 6.2064 19 5.23438V5.23438Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
